import React, { createContext, useContext, useState, useEffect } from 'react';
import { obtenerUsuarioAutenticado, logoutUsuario } from '../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const verificarAutenticacion = async () => {
    try {
      // Solo log en desarrollo si es necesario
      if (process.env.NODE_ENV === 'development') {
        // console.log('[AuthContext] Verificando autenticación...');
      }
      const userData = await obtenerUsuarioAutenticado();

      if (userData && userData.role !== "admin") {
        // Solo log en desarrollo si es necesario
        if (process.env.NODE_ENV === 'development') {
          // console.log('[AuthContext] Usuario autenticado (cliente):', userData);
        }
        setUser(userData);
        setIsLoggedIn(true);
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    } catch (err) {
      // Solo mostrar errores críticos en producción
      if (process.env.NODE_ENV === 'development') {
        console.error('[AuthContext] Error al verificar usuario:', err);
      }
      setUser(null);
      setIsLoggedIn(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificarAutenticacion();
  }, []);

  const logout = async () => {
    try {
      await logoutUsuario();
      setUser(null);
      setIsLoggedIn(false);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error al cerrar sesión', error);
      }
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, logout, verificarAutenticacion }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useUser = () => useContext(AuthContext);
